module.exports = __webpack_public_path__ + "img/littleImg08.ede0eb71.gif";